import en from "./en.json";
import ar from "./ar.json";
import tr from "./tr.json";
import ru from "./ru.json";
import fr from "./fr.json";
import es from "./es.json";
import zh from "./zh.json";

export const translations = {
  en,
  ar,
  tr,
  ru,
  fr,
  es,
  zh
};
